// removed by extract-text-webpack-plugin
module.exports = {"linkWrap":"wmf-2A_QW1X_","targetText":"wmf-3vZYzBnJ"};


//////////////////
// WEBPACK FOOTER
// ./src/compenents/ResourcePreviewContent/index.module.less
// module id = 1154
// module chunks = 0